
let accounting = require('accounting-js');

module.exports = function (val) {
    return accounting.formatMoney(val, { symbol: 'R ', precision: 2, thousand: ',', decimal: '.', });
};
